import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('react-root'),
);

// Learn more about service workers: https://bit.ly/CRA-PWA
// TODO: serviceWorker.register();
serviceWorker.unregister();
